import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  DOCUMENT,
} from '@angular/core';
import { PositionConfig } from 'devextreme/animation/position';
import dxPopup from 'devextreme/ui/popup';
import { Subscription } from 'rxjs';
import { getNumericCssVariables } from '../helpers/cssVariables';
import { DxPopupModule } from 'devextreme-angular/ui/popup';

@Component({
  selector: 'app-popup',
  template: `
    <dx-popup
      [showTitle]="!!title"
      [title]="this.title"
      [dragEnabled]="false"
      [hideOnOutsideClick]="false"
      [(visible)]="visible"
      [showCloseButton]="true"
      [position]="popupPosition"
      [height]="popupHeight"
      [width]="popupWidth"
      (onInitialized)="onPopupInit($event)"
    >
      <div *dxTemplate="let data of 'content'">
        <ng-content></ng-content>
      </div>
    </dx-popup>
  `,
  imports: [DxPopupModule],
})
export class PopupComponent implements OnInit, OnDestroy {
  @Output() public visibleChange = new EventEmitter<boolean>();

  @Input() public title!: string;

  @Input() public get visible() {
    return this._visible;
  }

  public set visible(visible: boolean) {
    if (visible !== this._visible) {
      this._visible = visible;
      this.visibleChange.emit(this._visible);
    }
  }

  public popupHeight!: number;
  public popupWidth!: number;
  public popupPosition!: PositionConfig;

  private _visible = false;
  private visibleSubscription?: Subscription;
  private popupInstance?: dxPopup;
  private layoutChangeWidth = 0;
  private headerHeight = 0;
  private sat = 0;

  private document = inject(DOCUMENT);

  public ngOnInit() {
    this.visibleSubscription = this.visibleChange.subscribe((visible: boolean) => {
      if (visible) {
        this.repaint();
      }
    });
  }

  public ngOnDestroy() {
    this.visibleSubscription?.unsubscribe();
  }

  // tslint:disable-next-line: prefer-inline-decorator
  @HostListener('window:resize')
  @HostListener('window:orientationchange')
  public repaint() {
    this.updateCssVariables();
    this.popupInstance?.repaint();
  }

  public onPopupInit(e: object) {
    // DevExtreme specifies an untyped object as event, even though properties are specified and typed
    // https://js.devexpress.com/Angular/Documentation/ApiReference/UI_Components/dxPopup/Configuration/#onInitialized
    this.popupInstance = e['component' as keyof typeof e] as unknown as dxPopup;
  }

  private updateCssVariables() {
    const keys = ['napp-popup-fullscreen-threshold-size', 'napp-header-height', 'sat'] as const;
    const cssVariables = getNumericCssVariables(window, this.document, keys);
    this.layoutChangeWidth = cssVariables[keys[0]];
    this.headerHeight = cssVariables[keys[1]];
    this.sat = cssVariables[keys[2]];
    if (window.innerWidth < this.layoutChangeWidth) {
      this.popupHeight = window.innerHeight - this.headerHeight - this.sat;
      this.popupWidth = window.innerWidth;
      this.popupPosition = { my: 'bottom', at: 'bottom', of: window };
    } else {
      this.popupHeight = window.innerHeight * 0.8; // Dx default
      this.popupWidth = window.innerWidth * 0.8; // Dx default
      this.popupPosition = { my: 'center', at: 'center', of: window };
    }
  }
}
